namespace GeniuzPOS.AdvPromo {
    export interface PsPromoTypeRow {
        Id?: number;
        PmType?: number;
        PPtype?: number;
        PmTypeDesc?: string;
        Condition?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        UpdateDate?: string;
    }

    export namespace PsPromoTypeRow {
        export const idProperty = 'PPtype';
        export const nameProperty = 'PmTypeDesc';
        export const localTextPrefix = 'AdvPromo.PsPromoType';
        export const lookupKey = 'AdvPromo.PsPromoType';

        export function getLookup(): Q.Lookup<PsPromoTypeRow> {
            return Q.getLookup<PsPromoTypeRow>('AdvPromo.PsPromoType');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = '*';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            PmType = "PmType",
            PPtype = "PPtype",
            PmTypeDesc = "PmTypeDesc",
            Condition = "Condition",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            UpdateDate = "UpdateDate"
        }
    }
}
